customElements.get('yo-slideshow') ??
  customElements.define(
    'yo-slideshow',
    class YO_Slideshow extends HTMLElement {
      constructor() {
        super();

        this.ns = '[YO/Slideshow]';

        console.log(`${this.ns} Init`, this);
      }

      connectedCallback() {
        this.swiper = new Swiper(this, {
          loop: true,
          autoplay: {
            delay: 8000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

        console.log(`${this.ns} connectedCallback()`, this);
      }
    },
  );
